<template>
  <div class="MainBox">
    <!-- 面包屑导航 -->
    <K-Column :column="column" v-if="this.$route.query.id"></K-Column>

    <div class="TableHead" v-if="!this.$route.query.id">
      <ul class="TableHeadLeft">
        <li class="TableHeadLeftRow btnStyleTwo blueBackColor btnRadius" @click="HandleModel(true)"><span class="icon iconfont iconicon-test20"></span>新增知识库</li>
      </ul>
      <ul class="clear"></ul>
    </div>

    <div class="TableMain">
      <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!datas"></K-Transition>
      <table class="table StripeTable" v-else>
        <thead>
          <tr>
            <th>编号</th>
            <th>名称</th>
            <th>类型</th>
            <th>字符数</th>
            <th>Token数</th>
            <th>分片最大Token数</th>
            <th>召回次数</th>
            <th>是否启用</th>
            <th>创建时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody class="TRHoverStyle">
          <tr v-for="(item, index) in datas" v-bind:key="index">
            <td v-text="item.id"></td>
            <td v-text="item.name"></td>
            <td v-text="item.type===0?'文档':'文本'"></td>
            <td v-text="item.content.length"></td>
            <td v-text="item.tokens"></td>
            <td v-text="item.segmentMaxTokens"></td>
            <td v-text="item.retrievalCount"></td>
            <td>
                <el-switch :active-value="0" :inactive-value="1" v-model="item.status" @change="changeHandle(item)"></el-switch>
            </td>
            <td v-text="item.createTime.replace('T', ' ')"></td>
            <td>
              <div class="btnArray">
                <a class="btnStyleTwo btnRadius greenBackColor" @click="HandleModel(true, item)">编辑</a>
                <a class="btnStyleTwo btnRadius orangeBackColor" @click="GoToPage(`AiDocspiece?id=${item.id}&title=${item.name}`)">分段</a>
                <a class="btnStyleTwo btnRadius redBackColor" @click="deleteHandle(item)">删除</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- 分页器 -->
      <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage" @SkipPage="SkipPage"></K-Paging>

    </div>

    <!-- 生码窗口 -->
    <div class="ModalBox" v-if="ModelShow">
      <div class="ModalMain">
        <div class="ModalMainHead">
          {{ FormDatas.id ? '编辑' : '新增' }}知识库
          <span class="icon iconfont iconicon-test29 ModalMainHeadClose feedback" @click="HandleModel(false)"></span>
        </div>
        <div class="ModalMainBox">
          <div class="FormStyleTwo">
            <div class="flex-box">
              <div class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle"><i>*</i>名称</p>
                <p><input v-model="FormDatas.name" placeholder="请输入" /></p>
              </div>
              <div class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle"><i>*</i>类型</p>
                <p>
                  <el-select v-model="FormDatas.type" placeholder="请选择">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </p>
              </div>
              <div class="FormStyleTwoRow">
                <p class="FormStyleTwoTitle"><i>*</i>切片大小</p>
                <p><input v-model="FormDatas.segmentMaxTokens" type="number" placeholder="请输入" :min="100" :max="800" /></p>
              </div>
            </div>
            <div class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle"><i>*</i>{{FormDatas.type == 1?'知识内容':'文件'}}</p>
              <p>
                <KUpload v-show="FormDatas.type == 0" :datas.sync="FormDatas.url" type="file" :list="fileList" />
                <KEditor v-show="FormDatas.type == 1" :datas.sync="FormDatas.content" />
              </p>
            </div>
          </div>
        </div>
        <div class="ModalMainFoot">
          <div class="ModalMainFootRight btnArray">
            <a class="btnStyleTwo btnRadius grayBackColor" @click="HandleModel(false)"v-text="$t('c.Common.Cancel')"></a>
            <a class="btnStyleTwo btnRadius blueBackColor" @click="SubmitForm()" v-text="$t('c.Common.Confirm')"></a>
          </div>
        </div>
      </div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

  </div>
</template>

<script>
import axios from 'axios'
import Paging from '@/components/common/Paging.vue'
import Transition from '@/components/common/Transition.vue'
import Loading from '@/components/common/Loading.vue'
import Confirm from '@/components/common/Confirm.vue'
import Toast from '@/components/common/Toast.vue'
import KEditor from '@/components/common/KEditor.vue'
import KUpload from '@/components/common/KUpload.vue'
import Column from '@/components/common/Column.vue'
import { deepClone } from '@/utils/utils'
export default {
  name: 'CodeManage',
  components: {
    KEditor,
    KUpload,
    'K-Column': Column,
    'K-Paging': Paging,
    'K-Transition': Transition,
    'K-Confirm': Confirm,
    'K-Loading': Loading,
    'K-Toast': Toast
  },
  data() {
    return {
      id: '',
      rowid: '',
      page: 1,
      pageSize: 20,
      subHint: '数据加载中...',
      isLoding: true,
      loading: false,
      Toast: {
        state: false,
        type: 0,
        txt: null
      },
      Confirm: {
        state: false,
        txt: null,
        style: 1
      },
      totalPages: 1,
      datas: null,
      ModelShow: false,
      defaultFormDatas: {},
      fileList: [],
      FormDatas: {
        id: '',
        name: '',
        type: 1,
        url: '',
        knowledgeId: localStorage.getItem("ai_knowledgeId"),
        segmentMaxTokens: 500,
        content: '',
      },
      options: [{
        value: 0,
        label: '文档'
      }, {
        value: 1,
        label: '文本'
      }],
      headers: { 
        'tenant-id': localStorage.getItem("ai_tenantId"),
        'token': localStorage.getItem("ai_Token") 
      },
      column:[{
        name:`知识库列表`,
        url:'AdminAiKnowledge'
      },{
          name:`「${this.$route.query.title}」文档列表`,
          url:'AiKnowledge?id='+this.$route.query.id
      }],
    }
  },
  created() {
    this.id = this.$route.query.id || localStorage.getItem("ai_knowledgeId");
    Object.assign(this.defaultFormDatas, this.FormDatas);
  },
  mounted() {
    this.GetList();
  },
  methods: {
    ToastFun(type, txt) {
      this.Toast.state = true;
      this.Toast.type = type;
      this.Toast.txt = txt;
    },
    ChangeToast() {
      this.Toast.state = false;
    },
    ChangePage(data) {  //上下翻页
      if (data.te == 1) {
        if (this.page > 1) {
          this.page--
        }
      } else {
        if (this.page < this.totalPages) {
          this.page++
        }
      }
      this.GetList();
    },
    SkipPage(data) {  //跳转分页
      this.page = data.ix;
      this.GetList();
    },
    SelectData(ix, six) {  //选中选择框内容
      this.SelectArr[ix].ix = six;
      this.SelectArr[ix].isHover = false;
    },
    HandleModel(status, item) {  //隐藏显示生码模态框
      this.ModelShow = status;
      if(item?.fileList){
        this.fileList = item.fileList;
      }
      Object.assign(this.FormDatas, item ? item : this.defaultFormDatas);
    },
    changeHandle(item){
      Object.assign(this.FormDatas, item);
      this.SubmitForm(true);
    },
    GetList() {
      this.datas = null;
      this.isLoding = true;
      this.subHint = "数据加载中...";
      axios.post(this.GetAiUrl() + `/ai/document/page`, {pageNo: this.page, pageSize: this.pageSize, knowledgeId: this.id}, { headers: this.headers })
        .then((response) => {
          this.isLoding = false;
          if (response.data.code == 0 && response.data.data.list.length) {
            this.datas = response.data.data.list.map(item=>{
              item.fileList = [{name: item.name, url: item.url}];
              return item;
            });
            this.totalPages = Math.ceil(response.data.data.total / this.pageSize);  //总页数
          } else {
            this.subHint = "数据为空";
          }
        }).catch((error) => {
          this.subHint = this.ErrorHint(error);
          this.isLoding = false;
        })
    },
    SubmitForm(noRefresh=false) {
      delete this.FormDatas.createTime
      let url = this.GetAiUrl() + `/ai/document/create`;
      let method = "POST";
      if (this.FormDatas.id) {
        method = "PUT";
        url = this.GetAiUrl() + `/ai/document/update`
        if(noRefresh){ //状态修改
          url = this.GetAiUrl() + `/ai/document/update-status`
        }
      }
      this.loading = true;
      axios({
        method,
        url,
        headers: this.headers,
        data: { ...this.FormDatas}
      }).then((response) => {
        this.loading = false;
        if (response.data.code == 0) {
          this.ToastFun(0, "成功");  //弹窗提醒
          this.HandleModel(false);
          if(!noRefresh){
            this.GetList();
          }
        } else {
          this.ToastFun(2, response.data.msg);  //弹窗提醒
        }
      }).catch((error) => {
        this.loading = false;
        this.ToastFun(2, this.ErrorHint(error));  //弹窗提醒
      })
    },
    deleteHandle(item) {
      this.rowid = item.id;
      this.Confirm.state = true;
      this.Confirm.txt = "是否确定删除该知识库吗？"
    },
    ConfirmBackFun(data) {
      this.Confirm.state = data.state;
      if (data.state) {
        this.Confirm.state = false;
        this.loading = true;
        axios({
          method: "delete",
          url: this.GetAiUrl() + `/ai/document/delete?id=${this.rowid}`,
          headers: this.headers
        }).then((response) => {
          this.loading = false;
          if (response.data.code == 0) {
            this.ToastFun(0, "删除成功");  //弹窗提醒
            this.GetList();
          } else {
            this.ToastFun(2, response.data.msg);  //弹窗提醒
          }
        }).catch((error) => {
          this.loading = false;
          this.ToastFun(2, this.ErrorHint(error));  //弹窗提醒
        })
      }
    },
  }
}
</script>

<style scoped lang="scss">
.RemainCode {
  display: block;
  color: #FFF;
  font-size: 13px;
  margin-top: 5px;
  padding: 5px 10px;
  border-radius: 3px;
  background-color: #F77851;
}

.flex-box {
  gap: 15px;
  display: flex;
  align-items: center;

  .FormStyleTwoRow {
    margin-top: 0;
    margin-bottom: 20px;
    width: calc(33.33% - 10px);
  }
}

.FormStyleTwoRow {
  margin-top: 0;
}

.el-select{
  width: 100%;
}
:deep .FormStyleTwo input{
  width: 100%;
}

.ModalMainBox>.FormStyleTwo input {
  width: 100% !important;
  box-sizing: border-box;
  padding: 0 10px;
}

.ModalMain {
  width: 80%;
}
</style>
